import { ValidationRuleValidDataType } from '../schema';

export function defaultValidationRule(): ValidationRuleValidDataType {
  return {
    code: '',
    condition: null,
    dataObjectDescriptionVersionId: -1,
    errorDescription: null,
    errorLevelId: -1,
    expressionLeft: '',
    expressionOperatorId: -1,
    expressionRight: '',
    groupCode: '',
    ignoreError: false,
    ignoreReason: '',
    statusId: -1,
    tolerance: 0,
    id: -1,
    validPeriod: [null, null],
  };
}
